<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{visible,params}">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getUnpack } from "@/api/order/unpack";
// import { getClient } from "@/api/user/client";
// import { getSku } from "@/api/storage/sku";
import { getSelectType } from "@/api/public";
import Tracker from "@/base/order_tracker";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import cTable from "@/base/common/index";
export default {
  name: "unpackEnquiry",
  components: {
    cTable,
    Tracker
  },
  mounted() {
    // this.header.searchs.forEach(async item => {
    //   if (item.key === "warehouse_id")
    //     item.options = (await getWarehouse()).data.payload.rows;
    // });
  },
  data() {
    let keywordsList = [
      { label: "orderNum", value: 1 },
      {
        label: "order_userRef",
        value: 2
      },
      { label: "bagNum", value: 3 },
      { label: "packing_number", value: 4 },
      { label: "mawb", value: 5 }
    ];
    return {
      methods: {
        list: getUnpack
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("pushProxy", row, true)
                .then(res => {
                  // this.$Message["success"]({
                  //   background: true,
                  //   content: res.msg,
                  //   duration: 5
                  // });
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("pushProxy"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        }
      },
      header: {
        searchs: [
          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: true,
            options: [],
            config: { label: ({ row }) => this.$t(row.label) },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["OMS_UNPACK_KEYWORDS"])).data
                  .payload["OMS_UNPACK_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            pushFun() {
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          // component: "Button",
          copy: true,
          align: "center",
          bind: {
            type: "primary",
            size: "small"
          },
          width: 150
          // methods: {
          //   click({ row }) {
          //     this.$page.getModal("show").setTitle(row.airway_number);
          //     this.$page.getModal("show").open({ row });
          //   }
          // }
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("operation") + this.$t("time"),
          key: "create_time",
          align: "center",
          minWidth: 180
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => "B2B" + this.$t("order_number"),
          key: "client_refer_code",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          align: "center",
          minWidth: 180,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          align: "center",
          minWidth: 125
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          align: "center",
          minWidth: 125
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("bagCode"),
          key: "package_number",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("warehouseName2"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center",
          minWidth: 100
        }
      ]
    };
  }
};
</script>
